import React from "react";
import styled from "styled-components";
import { Spacing } from "@glossy";
import Autocomplete from "@ui-kit/form/autocomplete";
import Button from "@ui-kit/form/button";
import Checkbox from "@ui-kit/form/checkbox";
import Chip from "@ui-kit/form/chip";
import Description from "@ui-kit/form/description";
import Fieldset from "@ui-kit/form/fieldset";
import Footer from "@ui-kit/form/footer";
import Label from "@ui-kit/form/label";
import PasswordStrength from "@ui-kit/form/password-strength";
import Radio from "@ui-kit/form/radio";
import Search from "@ui-kit/form/search";
import Select from "@ui-kit/form/select/simple";
import AsyncCreatableSelect from "@ui-kit/form/select/simple";
import Slider from "@ui-kit/form/slider";
import Text from "@ui-kit/form/text";
import TextAddMessage from "@ui-kit/form/text-add-message";
import Toggle from "@ui-kit/form/toggle";
import Tribox from "@ui-kit/form/tribox";

type IProps = React.FormHTMLAttributes<HTMLFormElement>;

const StyledForm = styled.form`
  > * + * {
    margin-top: ${Spacing.Large};
  }
`;

const UiKitForm = (props: IProps) => <StyledForm {...props} />;

export default UiKitForm;

export {
  AsyncCreatableSelect,
  Autocomplete,
  Button,
  Checkbox,
  Chip,
  Description,
  Fieldset,
  Footer,
  Label,
  PasswordStrength,
  Radio,
  Search,
  Select,
  Slider,
  Text,
  TextAddMessage,
  Toggle,
  Tribox,
};
